import { IPromise, IQService, module } from 'angular';

export class KubernetesV2ServerGroupTransformer {
  constructor(private $q: IQService) {
    'ngInject';
  }

  public normalizeServerGroup(serverGroup: any): IPromise<any> {
    return this.$q.when(serverGroup);
  }
}

export const KUBERNETES_V2_SERVER_GROUP_TRANSFORMER = 'spinnaker.kubernetes.v2.serverGroup.transformer.service';

module(KUBERNETES_V2_SERVER_GROUP_TRANSFORMER, [
]).service('kubernetesV2ServerGroupTransformer', KubernetesV2ServerGroupTransformer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/v2/serverGroup/serverGroupTransformer.service.ts